import React from 'react';
import { AppButton, Box, Text } from '@common-fe/common-fe';

import ModuleWrapper from '@/modules/plan/ModuleWrapper';

import { HEALTH_PLAN_MODULES } from '../../HealthPlan.constants';

import useCoverageLevelsContainer from './hooks/useCoverageLevelsContainer';
import useSyncAccountFundingConfigs from './hooks/useSyncAccountFundingConfigs';
import useSyncCategorySpendLimits from './hooks/useSyncCategorySpendLimits';
import AddCoverageLevel from './AddCoverageLevel';
import CoverageLevelsItem from './CoverageLevelsItem';

interface Props {
  isEditMode?: boolean;
  isTemplateMode?: boolean;
}

const CoverageLevels: React.FC<Props> = ({ isEditMode, isTemplateMode }) => {
  const {
    selectModalVisible,
    activateValidate,
    levels,
    excludeIds,
    filteredPlans,
    isPlansLoading,
    handleToggleModal,
    handleCloseModal,
    handleShowAddButton,
  } = useCoverageLevelsContainer();

  useSyncAccountFundingConfigs(filteredPlans, isTemplateMode, isPlansLoading);
  useSyncCategorySpendLimits(isTemplateMode);

  return (
    <ModuleWrapper
      testId="coverage-levels-wrapper"
      anchorId={HEALTH_PLAN_MODULES.COVERAGE_LEVELS}
      title={
        <Box direction="row" fill align="center" justify="between">
          <Text size="xxlarge" weight={700}>
            Coverage Levels
          </Text>
          {isEditMode && (
            <AppButton buttonType="secondary" onClick={handleShowAddButton}>
              Add Coverage Level
            </AppButton>
          )}
        </Box>
      }
      expandless
    >
      {!isEditMode && !levels.length && (
        <Box background="module" round="moduleRound" pad={{ vertical: 'spacing32' }}>
          <Box align="center">
            <Text weight={700} size="medium">
              There are no coverage levels
            </Text>
          </Box>
        </Box>
      )}
      {levels.map((item) => {
        if (!item) return null;

        return (
          <Box key={item.id} pad={{ bottom: 'l' }}>
            <CoverageLevelsItem
              coverageId={item.coverageId}
              isEditMode={isEditMode}
              isTemplateMode={isTemplateMode}
              isActiveMode={activateValidate}
              isDeletable={item.isDeletable}
              title={item.name || item.title}
              isHighlighted={item.isHighlighted}
            />
          </Box>
        );
      })}
      {isEditMode && (
        <AddCoverageLevel
          selectModalVisible={selectModalVisible}
          onToggleModalVisible={handleToggleModal}
          onCloseModal={handleCloseModal}
          excludeIds={excludeIds}
        />
      )}
    </ModuleWrapper>
  );
};

export default CoverageLevels;
